 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"balanceMismatch-balanceMismatch-module":"balanceMismatch-balanceMismatch-module","calendarEvent-calendar-event-module":"calendarEvent-calendar-event-module","canvg":"canvg","classification-classification-module":"classification-classification-module","default~Union-union-module~accountClassRestriction-accountclass-restriction-module~accountStatement-~0e1496ee":"default~Union-union-module~accountClassRestriction-accountclass-restriction-module~accountStatement-~0e1496ee","generalLedgerAccount-general-ledger-account-module":"generalLedgerAccount-general-ledger-account-module","mpesa-mpesa-module":"mpesa-mpesa-module","tdsRate-tds-rate-module":"tdsRate-tds-rate-module","default~Union-union-module~accountClassRestriction-accountclass-restriction-module~accountStatement-~7af2c010":"default~Union-union-module~accountClassRestriction-accountclass-restriction-module~accountStatement-~7af2c010","authorisation-authorisation-module":"authorisation-authorisation-module","batch-batch-module":"batch-batch-module","branch-branch-module":"branch-branch-module","accountClassRestriction-accountclass-restriction-module":"accountClassRestriction-accountclass-restriction-module","casaScheme-casa-scheme-module":"casaScheme-casa-scheme-module","cashierGlMaintenance-cashier-gl-maintenance-module":"cashierGlMaintenance-cashier-gl-maintenance-module","charge-charge-module":"charge-charge-module","clearingScheme-clearing-scheme-module":"clearingScheme-clearing-scheme-module","commissionInterest-commision-interest-module":"commissionInterest-commision-interest-module","currency-currency-module":"currency-currency-module","currencyexchangerate-currencyexchangerate-module":"currencyexchangerate-currencyexchangerate-module","dataSecurity-data-security-module":"dataSecurity-data-security-module","dataupload-dataupload-module":"dataupload-dataupload-module","default~Union-union-module~accountStatement-account-statement-module~accountStatementAll-account-sta~61ceb9a7":"default~Union-union-module~accountStatement-account-statement-module~accountStatementAll-account-sta~61ceb9a7","banktenant-banktenant-module":"banktenant-banktenant-module","common":"common","Union-union-module":"Union-union-module","default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~3d1b9dd2":"default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~3d1b9dd2","default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~7b323a2e":"default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~7b323a2e","default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~a82d854e":"default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~a82d854e","default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~621c38bb":"default~accountStatement-account-statement-module~accountStatementAll-account-statement-all-module~a~621c38bb","accountStatement-account-statement-module":"accountStatement-account-statement-module","accountStatementAll-account-statement-all-module":"accountStatementAll-account-statement-all-module","appraiser-appraiser-module":"appraiser-appraiser-module","bankNpaParameter-bank-npa-parameter-module":"bankNpaParameter-bank-npa-parameter-module","casaAccount-casa-account-module":"casaAccount-casa-account-module","clearing-clearing-module":"clearing-clearing-module","customer-customer-module":"customer-customer-module","loanAccount-loan-account-module":"loanAccount-loan-account-module","reports-reports-module":"reports-reports-module","termDepositAccount-term-deposit-account-module":"termDepositAccount-term-deposit-account-module","company-company-module":"company-company-module","customerFeedback-customer-feedback-module":"customerFeedback-customer-feedback-module","microFinanceCenter-micro-finance-center-module":"microFinanceCenter-micro-finance-center-module","overdraftAccount-overdraft-account-module":"overdraftAccount-overdraft-account-module","pigmyAccount-pigmy-account-module":"pigmyAccount-pigmy-account-module","productLevelNpa-product-level-npa-module":"productLevelNpa-product-level-npa-module","recurringDepositAccount-recurring-deposit-account-module":"recurringDepositAccount-recurring-deposit-account-module","shareAccount-share-account-module":"shareAccount-share-account-module","standinginstruction-standinginstruction-module":"standinginstruction-standinginstruction-module","shareDividend-share-dividend-module":"shareDividend-share-dividend-module","specialLoanAuthorisation-special-loan-authorisation-module":"specialLoanAuthorisation-special-loan-authorisation-module","deleteAccounting-delete-accounting-module":"deleteAccounting-delete-accounting-module","deleteTransaction-delete-transaction-module":"deleteTransaction-delete-transaction-module","deleteupload-delete-upload-module":"deleteupload-delete-upload-module","eoddetails-eoddetails-module":"eoddetails-eoddetails-module","ewalletRestriction-ewallet-restriction-module":"ewalletRestriction-ewallet-restriction-module","generalLedger-general-ledger-module":"generalLedger-general-ledger-module","internalFundTransfer-internal-fund-transfer-module":"internalFundTransfer-internal-fund-transfer-module","loanInterest-loan-interest-module":"loanInterest-loan-interest-module","loanScheme-loan-scheme-module":"loanScheme-loan-scheme-module","overdraftScheme-overdraft-scheme-module":"overdraftScheme-overdraft-scheme-module","paynow-pay-now-module":"paynow-pay-now-module","pigmyScheme-pigmy-scheme-module":"pigmyScheme-pigmy-scheme-module","recurringDepositInterest-recurring-deposit-interest-module":"recurringDepositInterest-recurring-deposit-interest-module","recurringDepositScheme-recurring-deposit-scheme-module":"recurringDepositScheme-recurring-deposit-scheme-module","shareScheme-share-scheme-module":"shareScheme-share-scheme-module","sourceChannel-source-channel-module":"sourceChannel-source-channel-module","ssbtransactionupload-ssbtransactionupload-module":"ssbtransactionupload-ssbtransactionupload-module","termDepositInterest-term-deposit-interest-module":"termDepositInterest-term-deposit-interest-module","termDepositScheme-term-deposit-scheme-module":"termDepositScheme-term-deposit-scheme-module","transactionCodewiseCharges-transactioncodewise-charges-module":"transactionCodewiseCharges-transactioncodewise-charges-module","transactiontype-transactiontype-module":"transactiontype-transactiontype-module","transactionupload-transactionupload-module":"transactionupload-transactionupload-module","yearEndProcess-provision-module":"yearEndProcess-provision-module","bank-bank-module":"bank-bank-module","unionDetails-union-module":"unionDetails-union-module","transaction-transaction-module":"transaction-transaction-module","userBranchRole-user-branchrole-module":"userBranchRole-user-branchrole-module","userRole-user-role-module":"userRole-user-role-module","invoice-invoice-module":"invoice-invoice-module","organizationdetail-organizationdetail-module":"organizationdetail-organizationdetail-module","externalBranch-external-branch-module":"externalBranch-external-branch-module","home-home-module":"home-home-module","loanProduct-loan-product-module":"loanProduct-loan-product-module","login-login-module":"login-login-module","user-user-module":"user-user-module","dompurify":"dompurify","financialDashboard-dashboard-financial-module":"financialDashboard-dashboard-financial-module","glsubgroup-glsubgroup-module":"glsubgroup-glsubgroup-module","group-group-module":"group-group-module","report-definition-report-definition-module":"report-definition-report-definition-module","reportmaster-reportmaster-module":"reportmaster-reportmaster-module","role-role-module":"role-role-module","role-screen-role-screen-module":"role-screen-role-screen-module","screen-screen-module":"screen-screen-module","subgroup-subgroup-module":"subgroup-subgroup-module"}[chunkId]||chunkId) + "-es2019.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
